import { render, staticRenderFns } from "./default.vue?vue&type=template&id=01167d92&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Nav: require('/opt/build/repo/components/Nav.vue').default,Contact: require('/opt/build/repo/components/contact/index.vue').default,MetaBallContainer: require('/opt/build/repo/components/MetaBallContainer.vue').default,ProjectTransition: require('/opt/build/repo/components/project/ProjectTransition.vue').default,NavContent: require('/opt/build/repo/components/NavContent.vue').default})
